import { MutationTree } from 'vuex';
import { DASHBOARD_FOURNISSEUR } from './mutation-types';
import { DashboardFournisseurState } from './state';
import { FactureFournisseurStatsDTO } from '@/models/FactureFournisseurStatsDTO';
import { ReglementDTO } from '@/models/ReglementDTO';

export const mutations: MutationTree<DashboardFournisseurState> = {

    [DASHBOARD_FOURNISSEUR.SET_STATS](state, stats: FactureFournisseurStatsDTO) {
        state.statsFactures = stats;
    },
    [DASHBOARD_FOURNISSEUR.SET_DERNIERS_REGLEMENTS](state, reglementDTOS: ReglementDTO[]) {
        state.reglementsDTO = reglementDTOS;
    },
};
